/**
 * Utilitaires pour gérer les rôles utilisateur de manière cohérente
 */

/**
 * Normalise les rôles pour éviter les incohérences
 * @param {string} role - Le rôle brut depuis l'API/base
 * @returns {string} - Le rôle normalisé ('viewer' ou 'creator')
 */
export const normalizeRole = (role) => {
  if (!role) return 'viewer'; // Défaut spectateur
  
  const normalizedRole = role.toLowerCase().trim();
  
  // Mapping des variations possibles vers les rôles standards
  const roleMap = {
    'viewer': 'viewer',
    'spectateur': 'viewer',
    'user': 'viewer',
    'member': 'viewer',
    'creator': 'creator',
    'createur': 'creator',
    'créateur': 'creator',
    'admin': 'creator', // Les admins sont aussi créateurs
    'moderator': 'creator'
  };
  
  return roleMap[normalizedRole] || 'viewer';
};

/**
 * Convertit un rôle technique en libellé français
 * @param {string} role - Le rôle technique ('viewer' ou 'creator')
 * @returns {string} - Le libellé en français
 */
export const getRoleLabel = (role) => {
  const normalizedRole = normalizeRole(role);
  
  const labels = {
    'viewer': 'Spectateur',
    'creator': 'Créateur'
  };
  
  return labels[normalizedRole] || 'Spectateur';
};

/**
 * Vérifie si un utilisateur est créateur
 * @param {string} role - Le rôle à vérifier
 * @returns {boolean} - True si créateur
 */
export const isCreator = (role) => {
  return normalizeRole(role) === 'creator';
};

/**
 * Vérifie si un utilisateur est spectateur
 * @param {string} role - Le rôle à vérifier  
 * @returns {boolean} - True si spectateur
 */
export const isViewer = (role) => {
  return normalizeRole(role) === 'viewer';
};

/**
 * Debug: affiche les informations sur un rôle
 * @param {string} role - Le rôle à déboguer
 * @param {string} source - La source du rôle (AuthContext, API, etc.)
 */
export const debugRole = (role, source = 'Unknown') => {
  console.log(`🔍 [${source}] Role Debug:`, {
    originalRole: role,
    normalizedRole: normalizeRole(role),
    isCreator: isCreator(role),
    isViewer: isViewer(role),
    frenchLabel: getRoleLabel(role)
  });
};